module.exports = {
      id: "logout-mobile-usage",
      viewBox: "0 0 20.886 28.808",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#logout-mobile",
      toString: function () {
        return this.url;
      }
    }